import React, { FC } from 'react';

import {
  Dialog, Typography, Box, Button, List,
  ListItem, makeStyles, createStyles, TextField,
} from '@material-ui/core';

import * as yup from 'yup';
import { useForm, OnSubmit } from 'react-hook-form';

const useStyles = makeStyles(() => createStyles({
  label: {
    width: '8rem',
  },
  textField: {
    width: '20rem',
  },
}));

interface CreateCatalogFormProps {
    name: string,
    label: string
}

const schema = yup.object().shape({
  name: yup.string().required(),
  label: yup.string().required(),
});

interface AddPricesheetDialogProps {
  open: boolean;
  onSubmit: OnSubmit<CreateCatalogFormProps>;
}

const CreateCatalogSpecDialog: FC<AddPricesheetDialogProps> = (props) => {
  const { onSubmit, open } = props;
  const { handleSubmit, register, errors } = useForm<CreateCatalogFormProps>({
    validationSchema: schema,
  });
  const classes = useStyles();

  return (
    <Dialog aria-labelledby="simple-dialog-title" open={open}>
      <Typography variant="h4" style={{ padding: '1rem' }}>Create new catalog spec</Typography>
      <Box style={{ paddingLeft: '2rem', paddingRight: '2rem' }} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <List>
          <ListItem>
            <Typography className={classes.label}>Name</Typography>
            <TextField
              required
              id="name"
              name="name"
              className={classes.textField}
              inputRef={register}
            />
            {errors.name && <Typography>{errors.name}</Typography>}
          </ListItem>
          <ListItem>
            <Typography className={classes.label}>Label</Typography>
            <TextField
              required
              id="label"
              name="label"
              className={classes.textField}
              inputRef={register}
            />
            {errors.label && <Typography>{errors.label}</Typography>}
          </ListItem>
        </List>
        <Box style={{ textAlign: 'center', paddingTop: '2rem' }}>
          <Button type="submit"><Typography variant="h6">Create Pricesheet Spec</Typography></Button>
        </Box>
      </form>
      <Box style={{ padding: '1rem' }} />
    </Dialog>
  );
};

export default CreateCatalogSpecDialog;
